module.exports = __webpack_public_path__ + "img/iripple-helpdesk-icon-dark.c569d876.png";